var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"downloaddark"},[_c('div',{staticClass:"icondark"},[_c('img',{attrs:{"src":require("@/assets/imgs/appstore_dark.png")},on:{"click":_vm.onAppStore}}),_c('img',{attrs:{"src":require("@/assets/imgs/googleplay_dark.png")},on:{"click":_vm.onGooglePlay}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }